export default __webpack_public_path__ + "static/media/mpeg.812673af.svg";